import React from 'react';
import BarChart from './BarChart';

export default function BarChartWidget({ data }) {
  return (
    <div
      className="report-widget report-kpi-card"
      style={{ width: 500 }}
    >
      <div className="report-widget__header">
        <div className="report-widget__inner">
          <h3 className="report-widget__title">Acesso por componente ao vivo - Top 10</h3>
        </div>
      </div>

      <div className="report-widget__body">
        <BarChart data={data} />
      </div>
    </div>
  );
}
